/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
// eslint-disable-next-line import/extensions
import axios from 'axios';
import _ from 'lodash';
import * as actionTypes from './ActionTypes';
import { v4 as uuidv4 } from 'uuid';

import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export const setSearchInvoiceAuditTab = (data) => {
  return {
    type: actionTypes.SEARCH_INVOICE_AUDIT_TAB_DATA,
    searchInvoiceAuditObj: data,
  };
};
export const setInvoiceAuditDetailTab = (data) => {
  return {
    type: actionTypes.INVOICE_AUDIT_DETAIL_TAB_DATA,
    invoiceAuditDetailObj: data,
  };
};
export const setSearchScreenTab = (data) => {
  return {
    type: actionTypes.SEARCH_SCREEN_TAB_DATA,
    searchScreenObj: data,
  };
};
export const setPervSearchInvoiceRedux = (data) => {
  return {
    type: actionTypes.PERV_SEARCH_INVOICE_CRITERIA_DATA,
    perviousInvoiceCriteriaRedux: data,
  };
};
export const dispatchPlanTypeFilterData = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  checkbox: data,
});

export const getCheckBoxValue = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanTypeFilterData(response.data));
    })
    .catch(() => {
      dispatch(dispatchPlanTypeFilterData([]));
    });
};

export const dispatchCommonDropdownData = (data) => ({
  type: actionTypes.GET_COMMON_DROPDOWN_DATA,
  dropdown: data,
});

export const getCommonDropdownList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return dispatch(dispatchCommonDropdownData(response.data));
    })
    .catch(() => {
      dispatch(dispatchCommonDropdownData([]));
    });
};
export const getPlanTypeRadioBoxValue = () => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      const tempObj = response.data;
      let updatedArray = [];
      if (tempObj?.PLAN_TYPE_CD?.length > 0) {
        const planArray = tempObj?.PLAN_TYPE_CD;
        planArray.map((element) => {
          if (element?.codeValueID?.codeValue === 'FD') {
            const indexOf = _.findIndex(planArray, element);
            if (!_.isNull(indexOf) && indexOf >= 0) {
              updatedArray = arrayMove(tempObj?.PLAN_TYPE_CD, indexOf, 0);
            }
          }
          return element;
        });
      }
      return updatedArray;
    })
    .catch(() => {
      return [];
    });
};
export const getRebateProgramDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchQuarterData = (data) => ({
  type: actionTypes.GET_QUARTER_DATA,
  quarter: data,
});

export const getQuarterData = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.UNDER_THRESHOLD_INVOICE_GET_MAX_QTR)
    .then((response) => {
      return dispatch(
        dispatchQuarterData(
          response.data && response?.data?.cmsMisMatchQtrResponseVO?.qtr
        )
      );
    })
    .catch(() => {
      dispatch(dispatchQuarterData(''));
    });
};

export const dispatchManufacturerData = (data) => ({
  type: actionTypes.GET_MANUFACTURER_DATA,
  manufacturerList: data,
});

export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MFG_LIST_BY_QTR, value)
    .then((response) => {
      return dispatch(
        dispatchManufacturerData(
          response.data && response.data.invoiceAuditResponse
        )
      );
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
    });
};
export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_IA,
  errorMessagesInRedux: data,
});

export const getAuditTypeDropDownList = (value) => {
  return axios
    .post(serviceEndPoint.GET_AUDIT_TYPE_LIST, value)
    .then((response) => {
      return response.data?.invoiceAuditResponse;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchInvoiceCriteriaList = (data) => ({
  type: actionTypes.GET_SEARCH_INVOICE_BY_CRITERIA,
  searchInvoiceByCriteriaList: data,
});

export const navigateToInvoiceAudit = (
  filter,
  onSuccess = () => {},
  onError = () => {}
) => {
  return async () => {
    try {
      const response = await axios.post(
        serviceEndPoint.GET_INVOICE_BY_CRITERIA_LIST,
        filter
      );

      if (
        response?.data?.invoiceAuditResponse?.invoiceAuditGridResponse?.length >
        0
      ) {
        dispatchInvoiceCriteriaList(response?.data?.invoiceAuditResponse);
        onSuccess();
      } else {
        onError();
      }
    } catch (e) {
      onError();
    }
  };
};

// eslint-disable-next-line consistent-return
export const getSearchInvoiceByCriteriaList = (value, action) => (dispatch) => {
  if (action === 'update') {
    dispatch(dispatchInvoiceCriteriaList(value));
  } else {
    return axios
      .post(serviceEndPoint.GET_INVOICE_BY_CRITERIA_LIST, value)
      .then((response) => {
        const tempObj = {
          ...response?.data?.invoiceAuditResponse,
          drugAuditResponses:
            response?.data?.invoiceAuditResponse?.drugAuditResponses?.map(
              (item) => {
                item.id = uuidv4();
                item.addEditRow = false;
                return item;
              }
            ),
        };
        return dispatch(dispatchInvoiceCriteriaList(tempObj));
      })
      .catch(() => {
        dispatch(dispatchInvoiceCriteriaList([]));
      });
  }
};
export const dispatchFindNDCLevelDetails = (data) => ({
  type: actionTypes.GET_NDC_LEVEL_DETAIL_LIST,
  ndcLevelDetailList: data,
});

export const getFindNDCLevelDetailList = (value, action) => (dispatch) => {
  if (action === 'update') {
    return dispatch(dispatchFindNDCLevelDetails(value));
  }
  // eslint-disable-next-line no-else-return
  else {
    return axios
      .post(serviceEndPoint.GET_NDC_LEVEL_DETAILS, value)
      .then((response) => {
        return dispatch(
          dispatchFindNDCLevelDetails(
            response.data && response.data.invoiceAuditResponse
          )
        );
      })
      .catch(() => {
        dispatch(dispatchFindNDCLevelDetails([]));
      });
  }
};
export const dispatchNDCAuditDes = (data) => ({
  type: actionTypes.GET_NDC_AUDIT_DESCRIPTION,
  ndcAuditDescriptionList: data,
});

// eslint-disable-next-line consistent-return
export const getNDCAuditDescription = (value, action) => (dispatch) => {
  if (action === 'update') {
    dispatch(dispatchNDCAuditDes(value));
  } else {
    return axios
      .post(serviceEndPoint.GET_NDC_AUDIT_DES_LIST, value)
      .then((response) => {
        const tempObj = response?.data?.invoiceAuditResponse;
        tempObj.drugSeqNum = value?.drugSeqNum;
        return dispatch(dispatchNDCAuditDes(tempObj));
      })
      .catch(() => {
        dispatch(dispatchNDCAuditDes([]));
      });
  }
};
export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: actionTypes.SAVE_OR_UPDATE,
  };
};
// eslint-disable-next-line consistent-return
export const postSaveOrUpdate = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchSaveOrUpdate(null));
  } else {
    return axios
      .post(serviceEndPoint.ADD_EDIT_INVOICE_DETAIL, value)
      .then((response) => {
        return dispatch(dispatchSaveOrUpdate(response.data));
      })
      .catch(() => {
        dispatch(dispatchSaveOrUpdate('failed'));
      });
  }
};
export const dispatchPagValue = (data) => ({
  type: actionTypes.PAGINATE_VALUE_FOR_DISPLAY,
  pagValueForDisplay: data,
});
export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
export const clearReduxForInvoiceAuditSearchScreen =
  () => (dispatch, getState) => {
    const reduxObj =
      getState()?.sharedState.InvoiceAuditsReducer?.errorMessagesInRedux;
    const errorMsgWithoutSearch = reduxObj?.searchScreenErrors
      ? reduxObj?.searchScreenErrors
      : [];
    dispatch(setSearchInvoiceAuditTab({}));
    dispatch(dispatchManufacturerData([]));
    dispatch(dispatchQuarterData(''));

    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(errorMsgWithoutSearch)],
        detailScreenErrors: reduxObj?.detailScreenErrors
          ? reduxObj?.detailScreenErrors
          : [],
      })
    );
  };
export const clearReduxForInvoiceAuditDetailScreen =
  () => (dispatch, getState) => {
    const reduxObj =
      getState()?.sharedState.InvoiceAuditsReducer?.errorMessagesInRedux;
    const errorMeg = reduxObj?.detailScreenErrors
      ? reduxObj?.detailScreenErrors
      : [];
    dispatch(setInvoiceAuditDetailTab({}));
    dispatch(dispatchNDCAuditDes([]));
    dispatch(dispatchSaveOrUpdate(''));
    dispatch(dispatchFindNDCLevelDetails([]));
    dispatch(dispatchInvoiceCriteriaList([]));
    dispatch(setPervSearchInvoiceRedux({}));
    dispatch(setChangesDataList([]));
    dispatch(selectedAuditType(''));

    dispatch(
      handleErrorMessages({
        searchScreenErrors: reduxObj?.searchScreenErrors
          ? reduxObj?.searchScreenErrors
          : [],
        detailScreenErrors: [...new Set(errorMeg)],
      })
    );
  };
// dispatch function for select all changes data list
export const setChangesDataList = (data) => ({
  type: actionTypes.ALL_CHANGES_INVOICE_AUDITS_DATA_LIST,
  changesDataList: data,
});
export const selectedAuditType = (val) => {
  return {
    type: actionTypes.SELECTED_INVOICE_AUDIT_TYPE,
    payload: val,
  };
};
